import * as ko from "knockout";
import template from './Anchor.html';

interface AnchorParams {
  text: ko.Observable<string> | string;
  uri: ko.Observable<string> | string;
}

class Anchor {

  text: ko.Observable<string>;
  uri: ko.Observable<string>;
  hasUri: ko.PureComputed<boolean>;

  constructor(params: AnchorParams) {
    // Handle both observable and plain string parameters
    this.text = ko.isObservable(params.text) ? params.text : ko.observable(params.text ?? "");
    this.uri = ko.isObservable(params.uri) ? params.uri : ko.observable(params.uri ?? "");

    this.hasUri = ko.pureComputed<boolean>(() => {
      const uriValue = this.uri();
      return uriValue !== null && uriValue !== undefined && uriValue !== "";
    });
  }
}

export default { viewModel: Anchor, template: template };
